export default __webpack_public_path__ + "static/media/cert-fsi-hkgcsmeaa-sc.2b33a026.jpg";